import { InjectionToken } from '@angular/core';

export const BASE_PATH = new InjectionToken<string>('basePath');

export const SEARCH_ENDPOINT = new InjectionToken<string>('searchApiPath');
